import { createSelector } from 'reselect'

const selectRedTeamSelf = (state) => state.redteam.self

export const selectCompanyProfile = (state) => selectRedTeamSelf(state).companyProfile
export const selectOsintCreditsLeft = (state) => selectRedTeamSelf(state).osintCreditsLeft
export const selectOsintLastUpdate = (state) => selectRedTeamSelf(state).osintLastUpdate
export const selectOsintNextSchedule = (state) => selectRedTeamSelf(state).osintNextSchedule
export const selectIsAgentActive = (state) => selectRedTeamSelf(state).isAgentActive
export const selectIntelligenceSources = (state) => selectRedTeamSelf(state).intelligenceSources
export const selectDefenseCoverage = (state) => selectRedTeamSelf(state).defenseCoverage
export const selectAttackGenerationData = (state) => selectRedTeamSelf(state).attackGenerationData
export const selectCompanyRisk = (state) => selectRedTeamSelf(state).companyRisk
export const selectRiskTrendWeeks = (state) => selectRedTeamSelf(state).riskTrendWeeks
export const selectTrainingActivity = (state) => selectRedTeamSelf(state).trainingActivity
export const selectTrainingActivityTotal = (state) => selectRedTeamSelf(state).trainingActivityTotal
export const selectTrainingActivityPage = (state) => selectRedTeamSelf(state).trainingActivityPage

export const selectRedTeamLoading = (state) => selectRedTeamSelf(state).loading
export const selectRedTeamError = (state) => selectRedTeamSelf(state).error

export const selectStatusLoading = createSelector(selectRedTeamLoading, (loading) => loading.status)
export const selectAttackGenerationLoading = createSelector(
  selectRedTeamLoading,
  (loading) => loading.attackGenerationData
)
export const selectCompanyRiskLoading = createSelector(
  selectRedTeamLoading,
  (loading) => loading.companyRisk
)
export const selectRiskTrendLoading = createSelector(
  selectRedTeamLoading,
  (loading) => loading.riskTrend
)
export const selectTrainingActivityLoading = createSelector(
  selectRedTeamLoading,
  (loading) => loading.trainingActivity
)

export const selectStatusError = createSelector(selectRedTeamError, (error) => error.status)
export const selectAttackGenerationError = createSelector(
  selectRedTeamError,
  (error) => error.attackGenerationData
)
export const selectTrainingActivityError = createSelector(
  selectRedTeamError,
  (error) => error.trainingActivity
)
